/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./ManualLink.vue?vue&type=template&id=7c4bb7c2"
import script from "./ManualLink.vue?vue&type=script&lang=js"
export * from "./ManualLink.vue?vue&type=script&lang=js"
import style0 from "./ManualLink.vue?vue&type=style&index=0&id=7c4bb7c2&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports